window.addEventListener('load', function(e) {
  var urlParams = new URLSearchParams(window.location.search);
  var myParam = urlParams.get('r');

  // window.setTimeout( function(){
  //   $('body.template-cart .page-width .sbc-cart-temporal-overlay').css('display', 'none');
  // }, 1300 );
  
  if(myParam && myParam === '1'){
      sbc_fillCart();
  } else {
    $('body.template-cart .page-width .sbc-cart-temporal-overlay').css('display', 'none');
  }
});

function sbc_fillCart(){  
  // first ajax call brings in items from external cart
  $.ajax({ 
    url: 'https://toccousa.com/wp-json/cart-content/v1/get-cart-content', 
    dataType: 'json',
    success: function(data){ 
      if(data.cart_data){
       	var d_items = [];
       	var items_array = data.cart_data.split(',');
        
        for(var items_it = 0; items_it < items_array.length; items_it++){
          var str_item_arr = items_array[items_it].split(':');
          
          var obj_item = {
            id: str_item_arr[0],
            quantity: str_item_arr[1]
          };
          
          d_items.push(obj_item);
        }
        
        // second ajax call clears cart selection
        $.ajax({
          url: '/cart/clear.js',
          method: 'post',
          dataType: 'json',
          success: function(){
          	// third ajax call fills cart with virtual cart received
            $.ajax({
              url: '/cart/add.js',
              method: 'post',
              dataType: 'json',
              data: {
                items: d_items,
                success: function(){
                	// last ajax call updates cart html (because liquid has precedence)
                  $.ajax({
                    url: '/cart.js',
                    method: 'get',
                    cache: false,
                    dataType: 'json',
                    success: function(data){
                      window.setTimeout(function(){
                        window.location = window.location.pathname;
                      }, 300);
                    }
                  });
                }
              }
            });
          }
        });
      }
    } 
  }); 
}
